import { useState } from 'react'

interface AdVideoEmbedProps {
    mediaUrl: string
    name: string
}

export function getMetaVideoEmbedSrc(mediaUrl: string): string | null {
    const normalized = mediaUrl.replace(/\/$/, '')

    if (
        normalized.includes('instagram.com/p/') ||
        normalized.includes('instagram.com/reel/')
    ) {
        return `${normalized}/embed/`
    }

    if (mediaUrl.includes('facebook.com')) {
        return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(mediaUrl)}&width=320&show_text=false&height=568`
    }

    return null
}

export function AdVideoEmbed({ mediaUrl, name }: AdVideoEmbedProps) {
    const [isLoading, setIsLoading] = useState(true)
    const src = getMetaVideoEmbedSrc(mediaUrl)

    if (!src) {
        return null
    }

    return (
        <div className="relative">
            {isLoading && (
                <div className="absolute inset-0 flex items-center justify-center bg-muted">
                    <span className="animate-pulse">Loading...</span>
                </div>
            )}
            <iframe
                src={src}
                width="320"
                height="568"
                className="border-0"
                title={name}
                loading="lazy"
                allowFullScreen
                onLoad={() => setIsLoading(false)}
            />
        </div>
    )
}
